import 'css-chunksrc/client/scenes/wbs/loader/styles.scss';export default {
  "loader": "_loader_1f9v8_1",
  "projectElement": "_projectElement_1f9v8_5"
};